import marked from 'marked'

const texts = {
  'Update': {'display': 'Speichern'},
  'Angelegt': {'display': 'angelegt'},
  'NeueAnfrage': {'display': 'Neue Anfrage'},
  'AnfrageAbgelehnt': {'display': 'Anfrage abgelehnt'},
  'InBearbeitung': {'display': 'in Bearbeitung'},
  'Bestaetigt': {'display': 'Bestätigt'},
  'Erledigt': {'display': 'Erledigt'},
  'Disponieren': {'display': 'Einladen'},
  'Abgeschlossen': {'display': 'Abgeschlossen'},
  'Storniert': {'display': 'Stornoiert'},
  'AuftragAblehnen': {'display': 'Stornieren'},
  'AuftragSchliessen': {'display': 'Kundenstorno'},
  'FastDispo': {'display': 'Fast Dispo'},
  'AnfrageAnnehmen': {'display': 'Bewerben'},
  'AnfrageAblehnen': {'display': 'Anfrage ablehnen'},
  'FastReply': {'display': 'Fast Reply'},
  'StatusUpdate': {'display': 'Status Update'},
  'DeleteAuftrag': {'display': 'Auftrag löschen'},
  'AuftragBestaetigen': {'display': 'Auftrag bestätigen'},
  'RechnungHochladen': {'display': 'Rechnung hochladen'},
  'Bewerten': {'display': 'Bewerten'},
  'ZurueckSetzen': {'display': 'Disposition neu beginnen'},
  'AuftragBeenden': {'display': 'Beenden'},
  'ProvisionBerechnen': {'display': 'Provision berechnen'},
  'RechnungVerschicken': {'display': 'Rechnung verschicken'}
}

export default {
  headerClass (user, auftrag, prefix) {
    if (user && auftrag && auftrag.__myAngebot && (auftrag.auftragStatus === 'Bestaetigt') && (user.id !== auftrag.cutterId) && (user.id !== auftrag.disponentId)) {
      return prefix + '-zugeteilt-anderer'
    }
    if (auftrag && (auftrag.auftragStatus === 'InBearbeitung') && auftrag.__myAngebot && (auftrag.__myAngebot.auftragAngebotStatus === 'Angenommen')) {
      return prefix + '-beworben'
    }
    return prefix + '-' + auftrag.auftragStatus
  },
  statusText (status) {
    if (texts[status] && texts[status].display) {
      return texts[status].display
    }
    return status
  },
  actionText (action) {
    if (texts[action.name] && texts[action.name].display) {
      return texts[action.name].display
    }
    return action.name
  },
  actionConfirm (action) {
    return 'Diese Aktion wirklich ausführen?'
  },
  makeToast (that, text, variant = null, title = null) {
    that.$bvToast.toast(text, {
      variant: variant,
      title: title,
      noclosebutton: true,
      solid: true
    })
  },
  mkTitel (auftrag, markup) {
    let result = auftrag.format.name + (markup ? '  ' : '') + '\n'
    let fields = ['firmaFormular', 'sendung', 'thema', 'tageFormular']
    for (let i = 0; i < fields.length; i++) {
      if (auftrag[fields[i]]) {
        result += auftrag[fields[i]]
        if (markup) {
          result += '  '
        }
        result += '\n'
      }
    }
    return markup ? marked(result) : result
  },
  laengeValues () {
    return {'30': '30', '45': '45', '52': '52', '60': '60', '90': '90', '120': '120'}
  },
  // 20 jahre zurück für die jahres auswahl
  yearValues () {
    let year = new Date().getFullYear()
    let result = []
    for (let i = year; i >= 1990; i--) {
      result.push(i)
    }
    return result
  },
  // return the roles stored in the token
  tokenRoles (token) {
    if (token === null) {
      return []
    }
    let base64Url = token.split('.')[1]
    let decodedValue = JSON.parse(window.atob(base64Url))
    return decodedValue.groups
  },
  // check if user has any of those roles
  hasAnyRole (hisRoles, roles) {
    for (let i = 0; i < roles.length; i++) {
      for (let x = 0; x < hisRoles.length; x++) {
        if (roles[i] === hisRoles[x]) {
          return true
        }
      }
    }
    return false
  },
  // check if user has any of those roles
  hasAnyUserRole (user, roles) {
    for (let i = 0; i < roles.length; i++) {
      if (this.hasRole(user, roles[i])) {
        return true
      }
    }
    return false
  },
  userRoles (user) {
    let result = []
    if (user.roles) {
      for (let i = 0; i < user.roles.length; i++) {
        result.push(user.roles[i].id)
      }
    }
    return result
  },
  // check if a user has a role
  hasRole (user, role) {
    if (user.roles) {
      for (let i = 0; i < user.roles.length; i++) {
        if (user.roles[i].id === role) {
          return true
        }
      }
    }
    return false
  },
  // trim a string to a maximum lenth
  excerpt (str, maxLength) {
    // trim the string to the maximum length
    let trimmedString = str.substr(0, maxLength)
    // re-trim if we are in the middle of a word
    trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(' ')))
    return trimmedString
  }
}



// WEBPACK FOOTER //
// ./src/main/vue/utilities.js